import {
  SURVEY_RESPONSES_BY_TOKEN,
  SURVEY_RESPONSES_BY_CLIENT,
  SURVEY_RESPONSES_BY_PROJECT,
  DB_RESPONSE_BY_CLIENT,
  DB_RESPONSE_BY_TOKEN,
  DB_QUESTION_GROUP,
} from "constants/ActionTypes"

const INIT_STATE = {
  survey_responses_by_token: null,
  survey_responses_by_client: null,
  survey_responses_by_project: null,
  db_responses_by_client: null,
  db_responses_by_token: null,
  db_question_group: null,
}

export default (state = INIT_STATE, action) => {
  switch(action.type) {
    case SURVEY_RESPONSES_BY_TOKEN: {
      return {
        ...state,
        survey_responses_by_token: action.payload.responses
      }
    }

    case SURVEY_RESPONSES_BY_CLIENT: {
      return {
        ...state,
        survey_responses_by_client: action.payload.responses
      }
    }

    case SURVEY_RESPONSES_BY_PROJECT: {
      return {
        ...state,
        survey_responses_by_project: action.payload.responses
      }
    }

    case DB_RESPONSE_BY_TOKEN: {
      return {
        ...state,
        db_responses_by_token: action.payload.response
      }
    }

    case DB_RESPONSE_BY_CLIENT: {
      return {
        ...state,
        db_responses_by_client: action.payload.response
      }
    }

    
    case DB_QUESTION_GROUP: {
      return {
        ...state,
        db_question_group: action.payload.result
      }
    }
    
    
    default:
      return state;
  }
}